import { Component } from "@angular/core";
import { StatsService } from "@/_services/stats.service";
import { LOCAL_STORAGE_KEYS } from "@/_models/filters/local-storage-keys";
import { StatsRiskResult } from "@/_models/stats-risk.interface";
import { PerformanceStatsLoader } from "@/components/statistics/performance-tab/performance-tab.component";

@Component({
    selector: "app-performance-risk-management",
    templateUrl: "./performance-risk-management.component.html",
})
export class PerformanceRiskManagementComponent {
    storageKey = LOCAL_STORAGE_KEYS.RISK_MANAGEMENT_FILTERS;
    loadStats: PerformanceStatsLoader<StatsRiskResult> = (filters) =>
        this.statsService.getRiskStats(filters);

    constructor(private statsService: StatsService) {}
}
